module.exports = __webpack_public_path__ + "static/media/GD.03bd9ec8.svg";